import { DataGrid } from "@mui/x-data-grid";

const GridForReadonlyData = ({rows, columns}) => {
    return <DataGrid
    sx={{ 
      flexGrow: 1,  
      '& .MuiDataGrid-columnHeaders': {
        fontSize: '1.1rem',
      },
      '& .MuiDataGrid-cell': {
        fontSize: '1rem',
      },
    }}
    rows={rows}
    columns={columns}
    initialState={{
      columns: {
      columnVisibilityModel: {
        id: false,
      }
    }}}
    disableColumnFilter
    disableColumnSelector
    disableDensitySelector
    disableRowSelectionOnClick={true}
    hideFooter
  />
}

export default GridForReadonlyData;